import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { ogpSharedService } from '../../../services';
import { OgpJobTypesData } from '../../../services/ogp-shared-service.types';

export const useGetOgpJobTypes = () => {
  return useQuery<OgpJobTypesData, Error>({
    queryKey: QUERY_KEYS.jobTypes(),
    queryFn: async () => await ogpSharedService.getJobTypes(),
  });
};
